import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { AuthGuard } from './guard/auth.guard';
import { apkBuildsRedirectGuard } from './guard/apk-builds-redirect.guard';
import { ProfilePage } from './pages/profile/profile.page';
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/root-redirect/root-redirect.page').then(
        (m) => m.RootRedirectPage,
      ),
  },

  {
    path: 'home',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },

  {
    path: 'rides',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/rides/rides.page').then((m) => m.RidesPage),
  },

  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },

  {
    path: 'register',
    loadComponent: () =>
      import('./pages/register/register.page').then((m) => m.RegisterPage),
  },

  {
    path: 'admin',
    canActivate: [NgxPermissionsGuard, AuthGuard],
    data: { permissions: { only: ['Admin'], redirectTo: 'login' } }, // Corrected 'Admin'
    loadComponent: () =>
      import('./pages/admin/admin.component').then((m) => m.AdminComponent),
  },
  {
    path: 'apk/apk',
    canActivate: [apkBuildsRedirectGuard],
    loadComponent: () =>
      import('./pages/admin/admin.component').then((m) => m.AdminComponent),
  },
  {
    path: 'apk/release',
    canActivate: [apkBuildsRedirectGuard],
    loadComponent: () =>
      import('./pages/admin/admin.component').then((m) => m.AdminComponent),
  },

  {
    path: 'register-driver',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/register-driver/register-driver.component').then(
        (m) => m.RegisterDriverComponent,
      ),
  },

  {
    path: 'find-ride',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/find-ride/find-ride.page').then((m) => m.FindRidePage),
  },

  {
    path: 'profile',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/profile/profile-stack.page').then(
        (m) => m.ProfileStackPage,
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: ProfilePage,
      },
      {
        path: ':section',
        loadComponent: () =>
          import('./pages/profile/profile-section.page').then(
            (m) => m.ProfileSectionPage,
          ),
      },
    ],
  },

  {
    path: 'add-offered-trip',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/add-offered-trip/add-offered-trip.page').then(
        (m) => m.AddOfferedTripPage,
      ),
  },

  {
    path: 'route-alert-add',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/route-alert-add/route-alert-add.page').then(
        (m) => m.RouteAlertAddPage,
      ),
  },

  {
    path: 'forgot-password',
    canDeactivate: [(component: { canLeave?: () => boolean }) => component.canLeave?.() !== false],
    loadComponent: () =>
      import('./pages/reset-password/reset-password.page').then(
        (m) => m.ResetPasswordPage,
      ),
  },
  {
    path: 'reset-password',
    canDeactivate: [(component: { canLeave?: () => boolean }) => component.canLeave?.() !== false],
    loadComponent: () =>
      import('./pages/reset-password/reset-password.page').then(
        (m) => m.ResetPasswordPage,
      ),
  },
  {
    // Legacy deep link — personal info lives under /profile/personal (with ion-content).
    path: 'user-details',
    redirectTo: '/profile/personal',
    pathMatch: 'full',
  },
  {
    path: 'trip-details',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/trip-details/trip-details.component').then(
        (m) => m.TripDetailsComponent,
      ),
  },
  {
    path: 'ride-details',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/ride-details/ride-details.component').then(
        (m) => m.RideDetailsComponent,
      ),
  },
  {
    path: 'driver-profile',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/driver-profile/driver-profile.page').then(
        (m) => m.DriverProfilePage,
      ),
  },
  {
    path: 'reserved-trips',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/reserved-trips/reserved-trips.component').then(
        (m) => m.ReservedTripsComponent,
      ),
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/notifications/notifications.component').then(
        (m) => m.NotificationsComponent,
      ),
  },
  {
    path: 'ride-results',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/ride-results/ride-results.component').then(
        (m) => m.RideResultsComponent,
      ),
  },
  {
    path: 'onboarding-notifications',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import(
        './pages/onboarding-notifications/onboarding-notifications.page'
      ).then((m) => m.OnboardingNotificationsPage),
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutesModule {}
